import { useState } from "react";
import { PALETTES, type Palette } from "./palettes";
import type { ArchMode } from "./bits";
import "./ReviewBar.css";

/** Floating review controls: palette and hero-arch mode, kept in the URL so a
    variation can be shared as a link. Not part of the design itself. */
export function ReviewBar({ palettes = PALETTES, palette, arch, onPalette, onArch }: { palettes?: Palette[]; palette: Palette; arch?: ArchMode; onPalette: (key: string) => void; onArch?: (a: ArchMode) => void }) {
  const [open, setOpen] = useState(true);
  if (!open) return <button type="button" className="p2r p2r-min" onClick={() => setOpen(true)} aria-label="Show review controls">
    <Dots p={palette} /><span>{palette.label}</span>
  </button>;
  return <div className="p2r" role="region" aria-label="Review controls">
    <span className="p2r-label">Palette</span>
    <div className="p2r-group">
      {palettes.map(p => <button key={p.key} type="button" aria-pressed={p.key === palette.key} onClick={() => onPalette(p.key)} title={p.label}>
        <Dots p={p} /><span>{p.label}</span>
      </button>)}
    </div>
    {onArch && <>
      <span className="p2r-label">Hero arch</span>
      <div className="p2r-group">
        {(["one", "none"] as const).map(a => <button key={a} type="button" aria-pressed={a === arch} onClick={() => onArch(a)}>{a === "one" ? "Keep" : "None"}</button>)}
      </div>
    </>}
    <button type="button" className="p2r-close" onClick={() => setOpen(false)} aria-label="Hide review controls">×</button>
  </div>;
}

function Dots({ p }: { p: Palette }) {
  return <i className="p2r-dots" aria-hidden="true">{[p.strong, p.soft, p.pop, p.h2].map((c, i) => <b key={i} style={{ background: c }} />)}</i>;
}
